/**
 * UNRAVEL — ZAMARITH Jeans
 * Selector de tallas + compra directa
 * Vanilla JS puro — sin dependencias
 */

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.unravel-card').forEach(function (card) {
    var botonesTag = card.querySelectorAll('.unravel-talla-btn');
    var btnComprar = card.querySelector('.unravel-btn-comprar');
    var mensaje    = card.querySelector('.unravel-msg-talla');
    var tallaSeleccionada = null;

    botonesTag.forEach(function (btn) {
      btn.addEventListener('click', function () {
        botonesTag.forEach(function (b) { b.classList.remove('activa'); });
        btn.classList.add('activa');
        tallaSeleccionada = btn.dataset.talla;
        if (mensaje) mensaje.style.display = 'none';
      });
    });

    if (btnComprar) {
      btnComprar.addEventListener('click', function () {
        if (!tallaSeleccionada) {
          if (mensaje) mensaje.style.display = 'block';
          return;
        }
        var links = {};
        try {
          links = JSON.parse(card.dataset.links || '{}');
        } catch (e) {
          return;
        }
        var url = links[tallaSeleccionada];
        if (url) window.location.href = url;
      });
    }
  });

});
